// @flow
import React from 'react';
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

const Block = styled.div`
  padding: 0 30px;
  text-align: center;

  ${maxMediaQueries.miniDesktop`
    padding-left: 24px;
    padding-right: 24px;
  `};

  ${maxMediaQueries.phone`
    padding-left: 15px;
    padding-right: 15px;
  `};
`;

const Inner = styled.div`
  display: inline-block;
  padding: 0 15px;
  border-radius: 24px;
  background-color: ${({ theme, white }) => (white ? theme.borderColor : theme.colors.uiLL)};
  font-variant: small-caps;
  color: ${({ theme }) => theme.colors.terciary};
  text-transform: lowercase;

  span {
    position: relative;
    top: -1px;
  }
`;

type Props = {
  white?: boolean,
  children: any
};

export const SectionTagTitle = ({ white, children }: Props) => (
  <Block>
    <Inner white={white}>
      <span>{children}</span>
    </Inner>
  </Block>
);
